@if(moduleId() == Navigation.NominalLedger || moduleId() == Navigation.PurchaseLedger || moduleId() == Navigation.SalesLedger){
    <fa-icon [icon]="['fas', moduleConfig()?.icon ?? 'box']" [mask]="['fas', 'bookmark']" transform="up-1 shrink-8" class="font-size-15rm" [class]="[iconColour()]"/>
}
@else {
    <fa-icon [icon]="['fas', moduleConfig()?.icon ?? 'box']" [class]="[iconColour()]"/>
}